// extracted by mini-css-extract-plugin
export default {"root":"home_root__Zk4IC","list":"home_list__GEe5p","note":"home_note__YxOht"};